import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './hooks/useAuth'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Projects from './pages/Projects'
import AgentTraining from './pages/AgentTraining'
import Settings from './pages/Settings'
import Analytics from './pages/Analytics'
import Conversations from './pages/Conversations'
import AgentWorkspace from './pages/AgentWorkspace'
import ProtectedRoute from './components/ProtectedRoute'
import RoleGuard from './components/RoleGuard'

const ADMIN_ROLES = ['superadmin', 'admin'] as const

/** Redirect to the right default page based on role */
function DefaultRedirect() {
  const { user } = useAuth()
  const role = user?.role || 'agent'
  if (role === 'agent') return <Navigate to="/agent" replace />
  return <Navigate to="/dashboard" replace />
}

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Login />} />
        <Route path="/" element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          <Route index element={<DefaultRedirect />} />
          <Route path="dashboard" element={<RoleGuard allowedRoles={[...ADMIN_ROLES]}><Dashboard /></RoleGuard>} />
          <Route path="projects" element={<RoleGuard allowedRoles={[...ADMIN_ROLES]}><Projects /></RoleGuard>} />
          <Route path="knowledge" element={<RoleGuard allowedRoles={[...ADMIN_ROLES]}><AgentTraining /></RoleGuard>} />
          <Route path="conversations" element={<RoleGuard allowedRoles={[...ADMIN_ROLES]}><Conversations /></RoleGuard>} />
          <Route path="settings" element={<RoleGuard allowedRoles={['superadmin']}><Settings /></RoleGuard>} />
          <Route path="analytics" element={<RoleGuard allowedRoles={[...ADMIN_ROLES]}><Analytics /></RoleGuard>} />
          <Route path="agent" element={<AgentWorkspace />} />
        </Route>
      </Routes>
    </AuthProvider>
  )
}

export default App